import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import { organizationsApi } from '../../api/organizations';
import { GQLArgs } from '../../types';

type NewHospitalResponse = { createOrganization: any };

export const useMutationNewHospital = (args?: GQLArgs<NewHospitalResponse>) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<NewHospitalResponse | undefined>();

  const mutation = useCallback(
    async ({ variables }: { variables: any }) => {
      setLoading(true);
      try {
        const res = await organizationsApi.create({
          name: variables.name,
          logo_url: variables.logoUrl,
          parent_organization_slug: variables.parentOrganizationSlug,
          ref_id: variables.refId,
        });
        const o = res.data;
        const shaped: NewHospitalResponse = {
          createOrganization: {
            name: o.name,
            logoUrl: o.logo_url,
            refId: o.ref_id,
            slug: o.slug,
            timeZone: o.time_zone,
            parent: null,
          },
        };
        setData(shaped);
        args?.onCompleted?.(shaped);
        toast.success('Hospital has been created', { autoClose: 5000 });
        return shaped;
      } catch (err: any) {
        args?.onError?.(err);
      } finally {
        setLoading(false);
      }
    },
    [args],
  );

  return { mutation, data, loading, error: undefined };
};
